import React from "react";
import { GetStaticProps } from "next";
import { Util } from "@xt/xtbase";

import { get_tdk } from "api/server/tdk";
import Layout from "@/components/Layout";
import Main from '@/components/Pages/schedule'

const { getOrigin } = Util;

interface Props {
  tdk?: any;
  resolvedUrl: string;
}

const SchedulePage: React.FC<Props> = () => {
  return (
    <Layout>
      <Main />
    </Layout>
  );
};

export default SchedulePage;

export const getStaticProps: GetStaticProps = async (context) => {
  const resolvedUrl = "/schedule";
  const props: Props = { resolvedUrl };

  try {
    const tdkUrl = getOrigin("www") + "/" + context.locale + resolvedUrl;
    const tdk = await get_tdk({
      params: {
        url: tdkUrl,
        languageType:
          context.locale == "zh-CN"
            ? "cn"
            : context.locale == "zh-HK"
            ? "hk"
            : context.locale,
      },
    });
    props.tdk = tdk || {};
  } catch (error) {
    console.log("get tdk error");
    console.log(error);
    props.tdk = {};
  }

  return {
    props,
    revalidate: 60,
  };
};
